import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { ngHelper } from '@cakeiteasy/web-utils';
import find from 'lodash/find';
import { ISelectItem } from '../../models/i-select-item';

@Component({
  standalone: false,
  selector: 'ui-select',
  templateUrl: './ui-select.component.html',
  styleUrls: ['./ui-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiSelectComponent implements OnChanges {
  @Input() items: ISelectItem[];
  @Input() placeholder: string;
  @Input() showToggle: boolean = true;
  @Input() resultFormatter: (m) => string = null;
  @Input() disabled: boolean;
  @Input() extraClasses: string = '';

  @Input()
  public get model() {
    return this.selectedItem;
  }

  public set model(value) {
    this.selectedItem = value;
  }

  @Output() modelChange: EventEmitter<ISelectItem> = new EventEmitter<ISelectItem>();

  public selectedItem: ISelectItem;

  ngOnChanges(changes: SimpleChanges): void {
    ngHelper.ifChanged(changes, 'model', (updatedModel: ISelectItem) => {
      this.selectedItem = find(this.items, { value: updatedModel.value });
    });
  }
}
